const ROOT = "vertical-embed";
const INSERT_VERTICAL_EMBED_MODAL = "verticalEmbedModal";
const INSERT_VERTICAL_EMBED_MODAL_ITEM = "verticalsItem";
const INSERT_VERTICAL_EMBED_MODAL_ITEM_IMAGE = "verticalsImage";
const INSERT_VERTICAL_EMBED_MODAL_SUBMIT = "actionButtonSave";

export { INSERT_VERTICAL_EMBED_MODAL, INSERT_VERTICAL_EMBED_MODAL_ITEM, INSERT_VERTICAL_EMBED_MODAL_ITEM_IMAGE, INSERT_VERTICAL_EMBED_MODAL_SUBMIT, ROOT };
//# sourceMappingURL=dataHooks.js.map
